// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3ePuF","info":"UpdateTermsInfo_info__WVL0d"};